"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.unionFragment = void 0;
// ideally we generatae these using an approach similar to the one described here:
// https://www.apollographql.com/docs/react/advanced/fragments.html#fragment-matcher
const unionFragment = {
    introspectionQueryResultData: {
        __schema: {
            types: [
                {
                    kind: 'UNION',
                    name: 'Insight',
                    possibleTypes: [
                        {
                            name: 'CropVarietyInsight'
                        },
                        {
                            name: 'SeedRateInsight'
                        },
                        {
                            name: 'NitrogenInsight'
                        },
                        {
                            name: 'PlantingDateInsight'
                        }
                    ]
                }
            ]
        }
    }
};
exports.unionFragment = unionFragment;
//# sourceMappingURL=fragments.js.map